import React, { useEffect } from 'react'
import { Router } from '@reach/router'
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import { LoadingSpinner } from './components/LoadingSpinner/LoadingSpinner'
import GlobalToast from './components/GlobalToast'
import { useLocalizedContent } from './hooks/useLocalizedContent'
import { useAppSelector } from './store/hooks'
import { selectIntroSheetState } from './store/slices/sheetsSlice'
import Intro from './screens/intro/Intro'

const MainRouterPage = React.lazy(() => import('./screens/main-router-page'))
const GroupDetail = React.lazy(() => import('./screens/groupdetail'))
const AdminGroupDetail = React.lazy(() => import('./screens/admingroupdetail'))

function App() {
  const isIntroShown = useAppSelector(selectIntroSheetState)
  const { getContent } = useLocalizedContent()
  const documentTitle = getContent('app.document.title')

  useEffect(() => {
    document.title = documentTitle
  }, [documentTitle])

  return (
    <ThemeWrapper theme={PAYPAL_THEME}>
      <React.Suspense
        fallback={
          <div>
            <LoadingSpinner size="xl" data-testid="loadingApp" />
          </div>
        }
      >
        <GlobalToast />
        {isIntroShown && <Intro />}
        <Router>
          <MainRouterPage path="/">
            {/*@ts-ignore : Not sure how to add a type for `path` */}
            <AdminGroupDetail path="/create" activateCreateFlow={true} />
            {/*@ts-ignore : Not sure how to add a type for `path` */}
            <AdminGroupDetail path="/create/resume" />
            {/*@ts-ignore : Not sure how to add a type for `path` */}
            <GroupDetail path="/:groupId" />
            {/*@ts-ignore : Not sure how to add a type for `path` */}
            <GroupDetail path="/:groupId/update-resume" />
            {/*@ts-ignore : Not sure how to add a type for `path` */}
            <AdminGroupDetail path="/" />
          </MainRouterPage>
        </Router>
      </React.Suspense>
    </ThemeWrapper>
  )
}

export default App
